/**
 * Virtual workflow entry step — materializes WorkflowInvocation input as a
 * DAG-addressable output so downstream steps can use depends_on / receives.
 */

/** Step id referenced in workflow DSL depends_on / receives.from. */
export const WORKFLOW_INPUT_STEP_ID = "workflow-input";

export interface WorkflowInputHandoff {
  readonly type: string;
  readonly version?: number;
  readonly payload: unknown;
}

export interface WorkflowInputOutput {
  readonly user_request: string;
  readonly handoff?: WorkflowInputHandoff;
}

export function buildWorkflowInputOutput(
  userRequest: string,
  handoff?: WorkflowInputHandoff,
): WorkflowInputOutput {
  return {
    user_request: userRequest,
    ...(handoff
      ? {
          handoff: {
            type: handoff.type,
            ...(handoff.version !== undefined ? { version: handoff.version } : {}),
            payload: handoff.payload,
          },
        }
      : {}),
  };
}

export function stepDependsOnWorkflowInput(
  dependsOn: readonly string[] | undefined,
): boolean {
  return dependsOn?.includes(WORKFLOW_INPUT_STEP_ID) ?? false;
}

export function formatWorkflowInputContext(output: WorkflowInputOutput): string {
  return `\n\n--- Step: ${WORKFLOW_INPUT_STEP_ID} ---\n${JSON.stringify(output, null, 2)}`;
}
